import { render, staticRenderFns } from "./InsuranceCompanyInformationDataTable.vue?vue&type=template&id=75cdd8e1"
import script from "./InsuranceCompanyInformationDataTable.vue?vue&type=script&lang=js"
export * from "./InsuranceCompanyInformationDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports